import { render, staticRenderFns } from "./studyBasics.vue?vue&type=template&id=2c47c7ce&"
import script from "./studyBasics.vue?vue&type=script&lang=js&"
export * from "./studyBasics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports